import React from "react";

export default function ContactNumber({ headingBg, text }) {
  const contactNumbers = [
    {
      location: "Global Headquarters",
      address: "20 Bay Street, 11th Floor, Toronto, ON, Canada, M5J2N8",
    },
    { location: "Toronto ON", number: "+1905-244-1300" },
    { location: "Vancouver BC", number: "+1778-244-1300" },
    { location: "Syracuse NY", number: "+1680-244-1300" },
    { location: "San Francisco CA", number: "+1628-244-1300" },
    { location: "Miami FL", number: "+1786-733-1300" },
    { location: "Toll Free", number: "+1855-243-1300" },
    { location: "India Toll Free", number: "+91-9819811300" },
  ];

  return (
    <div className="flex flex-col ">
      {/* Heading */}
      <h6 className={`footer-title tracking-wider ${headingBg} ${text}`}>
        24/7 Support available.
      </h6>

      {/* Contact List */}
      {contactNumbers.map((contact, index) => (
        <div key={index} className=" text-base">
          {contact.number ? (
            <a href={`tel:${contact.number}`} className="link-hover link py-1">
              {contact.location}: {contact.number}
            </a>
          ) : (
            <p className="text-base font-medium text-red-500">
              {contact.location}: {contact.address}
            </p>
          )}
        </div>
      ))}
    </div>
  );
}
